(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bedder-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bedder-home')) {
  customElements.define('bedder-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.bd-track');
      const slides = [...this.querySelectorAll('.bd-slide')];
      const selectors = [...this.querySelectorAll('.bd-selector')];
      const controls = this.querySelector('.bd-controls');
      const toggle = this.querySelector('[data-pause]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, paused = motion.matches || Boolean(window.Shopify?.designMode), hover = false, focused = false;
      const stop = () => clearTimeout(this.timer);
      const schedule = () => {
        stop();
        if (!paused && !hover && !focused && !document.hidden && slides.length > 1) this.timer = setTimeout(() => { show(current + 1); schedule(); }, 7000);
      };
      const label = () => { toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; };
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          if (active) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        });
        selectors.forEach((link, i) => { if (i === current) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
      };
      const manual = index => { paused = true; stop(); show(index); label(); };
      show(0);
      this.classList.add('is-ready');
      controls.hidden = false;
      label();
      selectors.forEach((link, i) => link.addEventListener('click', e => { e.preventDefault(); manual(i); }, { signal }));
      this.querySelector('[data-prev]').addEventListener('click', () => manual(current - 1), { signal });
      this.querySelector('[data-next]').addEventListener('click', () => manual(current + 1), { signal });
      toggle.addEventListener('click', () => { paused = !paused; label(); schedule(); }, { signal });
      const hoverArea = [track, this.querySelector('.bd-selectors'), controls];
      hoverArea.forEach(el => {
        el.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hover = true; stop(); } }, { signal });
        el.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { hover = false; schedule(); } }, { signal });
        el.addEventListener('focusin', () => { focused = true; stop(); }, { signal });
        el.addEventListener('focusout', () => { queueMicrotask(() => { focused = hoverArea.some(area => area.contains(document.activeElement)); schedule(); }); }, { signal });
      });
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); manual(current + (e.key === 'ArrowRight' ? 1 : -1)); } }, { signal });
      let startX = null, startY = null;
      track.addEventListener('touchstart', e => { startX = e.changedTouches[0].clientX; startY = e.changedTouches[0].clientY; stop(); }, { passive: true, signal });
      track.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - startX; const dy = e.changedTouches[0].clientY - startY; if (startX !== null && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) manual(current + (dx < 0 ? 1 : -1)); else schedule(); startX = null; }, { passive: true, signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      motion.addEventListener('change', () => { if (motion.matches) { paused = true; label(); stop(); } }, { signal });
      this.addEventListener('shopify:block:select', e => { const i = slides.findIndex(slide => slide === e.target || slide.contains(e.target)); if (i >= 0) manual(i); }, { signal });
      schedule();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guided-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bedder-guided-recommendations')) {
    customElements.define('bedder-guided-recommendations', class extends HTMLElement {
      connectedCallback() {
        // Wait for children when Shopify inserts this section in the theme editor.
        queueMicrotask(() => {
          if (this.isConnected && !this.abortController) this.initialize();
        });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
        cancelAnimationFrame(this.motionFrame);
        cancelAnimationFrame(this.syncFrame);
        cancelAnimationFrame(this.returnFrame);
        (this.links || []).forEach((link) => {
          ['data-bedder-path-link', 'aria-current', 'aria-expanded', 'aria-controls'].forEach(
            (attribute) => link.removeAttribute(attribute)
          );
        });
      }

      initialize() {
        this.panels = Array.from(this.querySelectorAll('[data-path-panel]'));
        if (!this.panels.length) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.findLinks();
        this.querySelectorAll('[data-guided-back], [data-guided-bottom]').forEach(
          (element) => { element.hidden = false; }
        );
        this.setAttribute('data-ready', '');
        this.selectFromLocation(false);
        if (this.panelForHash(location.hash)) {
          this.moveTo(this.panelForHash(location.hash), false, false);
        }

        document.addEventListener('click', (event) => this.handleClick(event), options);
        const sync = () => {
          cancelAnimationFrame(this.syncFrame);
          this.syncFrame = requestAnimationFrame(() => this.selectFromLocation(true));
        };
        window.addEventListener('hashchange', sync, options);
        window.addEventListener('popstate', sync, options);
        window.addEventListener('pageshow', sync, options);
        document.addEventListener('shopify:section:load', () => this.findLinks(), options);
      }

      panelForHash(hash) {
        return this.panels.find((panel) => '#' + panel.id === hash) || null;
      }

      pathForLink(link) {
        if (!link || !link.hasAttribute('href')) return null;
        try {
          const url = new URL(link.getAttribute('href'), location.href);
          const trim = (value) => value.replace(/\/$/, '');
          const host = (value) => value.replace(/^www\./, '');
          const store = new URL(this.dataset.shopUrl || location.origin, location.href);
          const sameStore = host(url.hostname) === host(location.hostname) ||
            host(url.hostname) === host(store.hostname);
          const samePage = trim(url.pathname) === trim(location.pathname) ||
            trim(url.pathname) === trim(this.dataset.pageUrl || location.pathname);
          return sameStore && samePage ? this.panelForHash(url.hash) : null;
        } catch (_) {
          return null;
        }
      }

      findLinks() {
        const scope = this.closest('main') || document;
        this.links = Array.from(scope.querySelectorAll('a[href*="#path-"]')).filter(
          (link) => !this.contains(link) && this.pathForLink(link)
        );
        this.links.forEach((link) => {
          const panel = this.pathForLink(link);
          link.setAttribute('data-bedder-path-link', '');
          link.setAttribute('aria-controls', panel.id);
          // Fallback to the existing card's heading if a namespace differs.
          if (!panel.dataset.pathHeading) {
            const card = link.closest('li, .multicolumn-card, article');
            const heading = card && card.querySelector('h2, h3, h4');
            const title = heading && heading.textContent.trim();
            if (title) {
              panel.dataset.pathHeading = title;
              panel.querySelector('[data-path-title]').textContent = 'Recommended for ' + title;
            }
          }
        });
        this.updateLinkStates();
      }

      updateLinkStates() {
        (this.links || []).forEach((link) => {
          const panel = this.pathForLink(link);
          const selected = panel && panel.id === this.dataset.activePath;
          link.setAttribute('aria-expanded', String(Boolean(selected)));
          if (selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }

      showPanel(panel) {
        this.panels.forEach((item) => { item.hidden = item !== panel; });
        this.dataset.activePath = panel ? panel.id : '';
        this.updateLinkStates();
      }

      handleClick(event) {
        if (event.defaultPrevented || event.button !== 0 ||
            event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!(event.target instanceof Element)) return;
        const back = event.target.closest('[data-guided-back]');
        if (back && this.contains(back)) {
          event.preventDefault();
          this.returnToChoices(true);
          return;
        }
        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') ||
            (link.target && link.target !== '_self')) return;
        const panel = this.pathForLink(link);
        if (!panel) return; // Never intercept unrelated or product-page links.
        event.preventDefault();
        this.findLinks();
        this.lastTrigger = link;
        cancelAnimationFrame(this.returnFrame);
        this.showPanel(panel);
        this.writeHash('#' + panel.id);
        this.moveTo(panel, true, true);
        // Optional integration hook. This does NOT automatically send analytics.
        this.dispatchEvent(new CustomEvent('bedder:path-selected', {
          bubbles: true,
          detail: {
            path: Number(panel.dataset.pathNumber),
            heading: panel.dataset.pathHeading,
            page: location.pathname
          }
        }));
      }

      writeHash(hash) {
        if (location.hash === hash) return;
        const url = new URL(location.href);
        url.hash = hash;
        try {
          // Preserve the current query string, including advertising UTMs.
          history.pushState(history.state, '', url.pathname + url.search + url.hash);
        } catch (_) {
          location.hash = hash;
        }
      }

      selectFromLocation(move) {
        const previous = this.dataset.activePath;
        const panel = this.panelForHash(location.hash);
        if (move && previous && !panel && !location.hash) {
          this.returnToChoices(false);
          return;
        }
        cancelAnimationFrame(this.returnFrame);
        this.showPanel(panel);
        if (move && panel) this.moveTo(panel, previous !== panel.id, false);
      }

      choicesTarget() {
        const scope = this.closest('main') || document.querySelector('main') || document;
        const usable = (element) => {
          if (!(element instanceof HTMLElement) || !element.isConnected ||
              this.contains(element) || element.closest('footer, nav, [hidden], [aria-hidden="true"]')) {
            return false;
          }
          // Never select a footer or a heading located below the recommendations.
          if (!(element.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
          const box = element.getBoundingClientRect();
          return box.width > 1 && box.height > 1 && getComputedStyle(element).visibility !== 'hidden';
        };

        // Optional explicit marker, supported without requiring a template edit.
        const marked = Array.from(scope.querySelectorAll('[data-bedder-sleep-options], #bedder-sleep-options'))
          .find(usable);
        if (marked) return marked;

        const headings = Array.from(scope.querySelectorAll('h1, h2, h3, h4, [role="heading"]'))
          .filter(usable);
        const normalize = (text) => text.replace(/\s+/g, ' ').trim().toLowerCase();
        const named = headings.find((heading) =>
          normalize(heading.textContent).startsWith('what matters most to your sleep')
        );
        if (named) return named;

        // If the section title is renamed later, use the heading above the
        // real pathway cards, not the hero heading or a product-card heading.
        const link = (this.lastTrigger && usable(this.lastTrigger) && this.pathForLink(this.lastTrigger))
          ? this.lastTrigger : (this.links || []).find(usable);
        if (!link) return null;
        const section = link.closest('.multicolumn, .shopify-section, section');
        const sectionHeading = section && headings.find((heading) =>
          section.contains(heading) && !heading.closest('li, .multicolumn-card, article') &&
          (heading.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_FOLLOWING)
        );
        // A verified choice-card link is a safe last resort; never use a footer.
        return sectionHeading || link;
      }

      returnToChoices(focus) {
        this.findLinks();
        const target = this.choicesTarget();
        if (!target) {
          console.warn('Bedder guided recommendations: pathway choices could not be found.');
          return; // Keep the products visible instead of sending the shopper elsewhere.
        }
        cancelAnimationFrame(this.motionFrame);
        cancelAnimationFrame(this.syncFrame);
        cancelAnimationFrame(this.returnFrame);

        // Move focus and the viewport BEFORE collapsing the tall product panel.
        // This prevents the shorter page from leaving the viewport at the footer.
        this.moveTo(target, focus, false);
        this.showPanel(null);
        this.writeHash('');
        this.moveTo(target, false, false);

        // Re-align after layout settles, without a long scroll past unrelated content.
        this.returnFrame = requestAnimationFrame(() => {
          this.returnFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.dataset.activePath === '' && target.isConnected) {
              this.moveTo(target, false, false);
            }
          });
        });
      }

      moveTo(target, focus, smooth) {
        if (!target || !target.isConnected) return;
        const focusTarget = target.querySelector('[data-path-title]') || target;
        if (focus) {
          if (!focusTarget.matches('a, button, input, select, textarea, [tabindex]')) {
            focusTarget.setAttribute('tabindex', '-1');
          }
          focusTarget.focus({ preventScroll: true });
        }
        cancelAnimationFrame(this.motionFrame);
        const scroll = () => {
          if (!target.isConnected) return;
          const configured = Number(this.dataset.scrollOffset) || 120;
          const header = document.querySelector('.section-header, sticky-header');
          const headerHeight = header ? header.getBoundingClientRect().height : 0;
          const offset = Math.max(configured, headerHeight + 16);
          const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: smooth && !reducedMotion ? 'smooth' : 'instant' });
        };
        if (smooth) this.motionFrame = requestAnimationFrame(scroll);
        else scroll();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
